import styled from "styled-components";
import CardFrame from "./CardFrame";
import RocketLaunchIcon from "icons/RocketLaunchIcon";
import { GridContainer } from "./HomeStyle";
import ImageCaptionIcon from "icons/ImageCaptionIcon";
import LightBulbIcon from "icons/LightBulbIcon";
import { useHistory } from "react-router-dom";

const Card = styled.div`
  display: flex;
  padding: 16px 12px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  background: ${(props) => props.bg || "#EBF4FE"};
  box-shadow: 0px 0px 6px 1px rgba(167, 175, 180, 0.05);
  text-align: left;
  cursor: pointer;
  position: relative;

  &:hover {
    scale: 1.02;
  }

  .iconWrapper {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    position: absolute;
    right: -8px;
    top: -8px;
    border-radius: 48px;
    background: #fff;
    box-shadow: 0px 0px 6px 1px rgba(167, 175, 180, 0.05);
  }
`;

const aiData = [
  {
    text: "Get Instant Captions",
    bg: "#EBF4FE",
    icon: <RocketLaunchIcon color="#063F93" />,
    target: "/dashboard/ai-assistant",
  },
  {
    text: "Get caption from Images",
    bg: "#FFECE5",
    icon: <ImageCaptionIcon color="#AD3307" />,
    target: "/dashboard/ai-assistant",
  },
  {
    text: "Get Instant Post Ideas",
    bg: "#FFFAE5",
    icon: <LightBulbIcon color="#FFCC00" />,
    target: "/dashboard/ai-assistant",
  },
  {
    text: "Write captions with AI",
    bg: "#EBF6FF",
    icon: <RocketLaunchIcon color="#063F93" />,
    target: "/dashboard/ai-assistant",
  },
];

const AiAssitantSection = () => {
  const history = useHistory();

  const handleCardClick = (target) => {
    history.push(target);
  };
  return (
    <CardFrame headerText={"AI Assistant"}>
      <GridContainer
        columns="repeat(4, 1fr)"
        gap="16px"
        mbColumn="repeat(2, 1fr)"
      >
        {aiData.map((item, index) => (
          <Card
            bg={item.bg}
            key={index}
            onClick={() => handleCardClick(item.target)}
          >
            <div className="iconWrapper">{item.icon}</div>
            <div className="l3">{item.text}</div>
          </Card>
        ))}
      </GridContainer>
    </CardFrame>
  );
};

export default AiAssitantSection;
